import { useQuery } from "react-query";
import {
  getEmployeeType,
  getEmployeeTypeFilter,
} from "../../../../../actions/Utilities/EmployeeType";

export const useEmployeeType = () => {
  const { data } = useQuery("GetEmployeeType", getEmployeeType, {
    refetchOnWindowFocus: false,
  });
  return data;
};

export const useEmployeeTypeFilter = () => {
  return useQuery("GetEmployeeTypeFilter", getEmployeeTypeFilter, {
    refetchOnWindowFocus: false,
  });
};
